export interface ScheduleTime {
  start: string;
  end: string;
}

class Schedule {
  Monday: ScheduleTime;
  Tuesday: ScheduleTime;
  Wednesday: ScheduleTime;
  Thursday: ScheduleTime;
  Friday: ScheduleTime;
  Saturday: ScheduleTime;
  Sunday: ScheduleTime;
}

function createSchedule(blob: any): Schedule {
  const schedules = {};

  (Object.keys(blob) || []).forEach(day => {
    const [start, end] = blob[day].split(' - ');
    const strStartTime = String(`0${start}`);
    const strEndTime = String(`0${end}`);

    schedules[day] = {
      start: strStartTime.substring(strStartTime.length - 8),
      end: strEndTime.substring(strEndTime.length - 8),
    };
  });

  return schedules as any;
}

export function createConfiguration(blob: any): Configuration {
  return new Configuration({
    canBookOnline: !!blob.accept_booking_online,
    canBookAnyTime: !!blob.accept_all_appointments,
    canBookOnMonday: !!blob.accept_booking_on_mon,
    canBookOnTuesday: !!blob.accept_booking_on_tue,
    canBookOnWednesday: !!blob.accept_booking_on_wed,
    canBookOnThursday: !!blob.accept_booking_on_thu,
    canBookOnSaturday: !!blob.accept_booking_on_sat,
    canBookOnFriday: !!blob.accept_booking_on_fri,
    canBookOnSunday: !!blob.accept_booking_on_sun,
    canPayByCreditCard: !!blob.accept_online_payment,
    mustPayByCreditCard: !!blob.require_pay_online,
    hasDefaultStylist: !blob.hide_no_preference,
    minimumAdvancedBookingHours: blob.minimum_advanced_booking_hours,
    maximumAdvancedBookingDays: blob.maximum_advanced_booking_days,
    depositAmount: blob.require_pay_amount,
    paymentTerms: (blob.booking_term || '').trim().split('\n').filter(line => !!line),
    schedules: createSchedule(blob.schedule),
  });
}

export class Configuration {
  canBookAnyTime: boolean = false;
  canBookOnline: boolean = false;
  canBookOnThursday: boolean = false;
  canBookOnSunday: boolean = false;
  canBookOnSaturday: boolean = false;
  canBookOnWednesday: boolean = false;
  canBookOnTuesday: boolean = false;
  canBookOnMonday: boolean = false;
  canBookOnFriday: boolean = false;
  canPayByCreditCard: boolean = false;
  mustPayByCreditCard: boolean = false;
  hasDefaultStylist: boolean = false;
  minimumAdvancedBookingHours: number = 0;
  maximumAdvancedBookingDays: number = 0;
  depositAmount: number = 0;
  paymentTerms: string[] = [];
  schedules: Record<string, ScheduleTime> = {};

  constructor(fields: any) {
    Object.assign(this, fields);
  }
}
